export const BACKUP_GROUP_TYPE = 'BACKUP_GROUP_TYPE';
export const MACHINES_TABLE_TYPE = 'MACHINES_TABLE_TYPE';
export const CONTENT_TABLE_TYPE = 'CONTENT_TABLE_TYPE';
export const SHARED_CONTENT_TABLE_TYPE = 'SHARED_CONTENT_TABLE_TYPE';
export const ACCOUNT_PAGE_CONTENT_TYPE = 'ACCOUNT_PAGE_CONTENT_TYPE';
export const RESOURCES_PAGE_CONTENT_TYPE = 'RESOURCES_PAGE_CONTENT_TYPE';
export const UNDEFINED_CONTENT_TYPE = '';
